import React, { useContext } from 'react'
import { SuspenseWithPerf } from 'reactfire'

import { AuthContext } from '../Firebase/Auth'
import Ripple from './Ripple'

const LoadUserID = (props) => {
  const { currentUser } = useContext(AuthContext)
  if (!currentUser) return <Ripple />

  return (
    <SuspenseWithPerf fallback={<Ripple />} traceId={'load-user-id'}>
      {props.userID
        ? React.cloneElement(props.children, {
            ...props
          })
        : React.cloneElement(props.children, {
            userID: currentUser.uid,
            ...props
          })}
    </SuspenseWithPerf>
  )
}
export default LoadUserID
